<div
    role="radioGroup"
    class="agpr-tabsToggle"
>
    @for (option of options; track option.value; let i = $index) {
        <input
            type="radio"
            class="u-srOnly"
            [id]="id + '_tabsToggleOption' + i"
            [value]="option.value"
            [attr.tabindex]="option.value === value ? '0' : '-1'"
            (focus)="focusToggle(true)"
            (blur)="focusToggle(false)"
            [(ngModel)]="value"
            (ngModelChange)="onRadioChanged($event)"
        >
        <div
            class="agpr-tabsToggle-option"
            [ngClass]="{'agpr-tabsToggle-icon': option.icon, 'agpr-tabsToggle-text': option.label}">
            <label
                [id]="id + '_' + option.value"
                class="agpr-tabsToggle-label"
                [ngClass]="{
                    'agpr-tabsToggle-label--selected': value === option.value,
                    'agpr-tabsToggle-label--focused': value === option.value && focused
                }"
                [for]="id + '_tabsToggleOption' + i"
            >

                @if (option.label) {
                    <span class="agpr-tabsToggle-labelText">
                        {{ option.label | localize }}
                    </span>
                } @else if (option.icon) {
                    <span
                        class="agpr-tabsToggle-labelIcon"
                        role="img"
                        [ngClass]="[
                            value === option.value ? 'fa-solid' : 'fa-regular',
                            option.icon,
                            value === option.value ? 'agpr-tabsToggle-icon--selected' : ''
                        ]"
                        [pTooltip]="option.tooltip | localize"
                        tooltipPosition="top"
                        >
                    </span>
                }
            </label>
        </div>
    }
</div>
